import * as React from "react";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useScrollTrigger } from "@mui/material";
import EventCard from "../card";
import Container from "@mui/material/Container";
import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  IconButton,
  InputBase,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { SelectChangeEvent } from "@mui/material/Select";
import FilterListIcon from "@mui/icons-material/FilterList";
import "./event.css";
import EventForm from "./eventForm";
import { useAppDispatch, useAppSelector } from "../../helpers/hooks";
import { createEvent } from "../../features/eventDetails/createEventSlice";
import {
  listEvent,
  searchEvent,
  totalEventCount,
  searchEventsCount,
} from "../../features/eventDetails/eventListSlice";
import { fetchEventCategories } from "../../features/eventDetails/eventCategorySlice";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import dayjs from "dayjs";
import Toaster from "../toaster";
import Loader from "../loader";

export default function EventList() {
  const dispatch = useAppDispatch();
  const trigger = useScrollTrigger();
  const [isLoading, setIsLoading] = React.useState(true);
  const [openToaster, setOpenToaster] = React.useState(false);
  const [disablePublish, setDisablePublish] = React.useState(false);
  const [location, setLocation] = React.useState("");
  const [keyword, setKeyword] = React.useState("");
  const [filter, SetFilter] = React.useState<string[]>([]);
  const [filters, setFilters] = React.useState<string[]>([]);
  const [filterForSearch, setFilterForSearch] = React.useState([]);
  const eventCategories = useAppSelector(
    (state) => state.eventCategories.eventCategories
  );
  const [eventData, setEventData] = React.useState<string[]>([]);
  const events = useAppSelector((state) => state.eventList.eventList);
  const [open, setOpen] = React.useState(false);
  const [selectOpen, setSelectOpen] = React.useState(false);
  const createEventFormTitle = "Create Event";
  const user = useAppSelector((state) => state.userProfile.profile);
  const [pageNo, setPageNo] = React.useState(1);
  const [total, setTotal] = React.useState(0);
  const [eventLoadingMessage, setEventLoadingMessage] =
    React.useState("Loading Events...");
  const [toastType, setToastType] = React.useState("");
  const [toastMessage, setToastMessage] = React.useState("");
  const totelEveCount = useAppSelector(
    (state) => state.eventList.totalEventCount
  );

  const openCreateEventForm = () => {
    setOpen(true);
  };

  const handlePopupClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    trigger && handleClose();
  }, [trigger]);

  const handleToasterClose = () => {
    setOpenToaster(false);
  };

  const handleChange = (event: SelectChangeEvent) => {
    setLocation(event.target.value);
    setPageNo(1);
  };

  const handleInputChange = (event: any) => {
    setKeyword(event.target.value);
    setPageNo(1);
  };

  const getSearchParam = (filterParam?: any) => {
    let qp = "";
    if (keyword !== "") {
      qp = `keyword=${keyword}`;
    }
    if (location !== "") {
      qp = qp + `${keyword ? "&" : ""}location=${location}`;
    }
    if (filterParam?.length) {
      filterParam.forEach((item: any) => {
        qp =
          qp +
          `${keyword || location ? "&" : ""}filter=${item}${
            filterParam.length > 1 ? "&" : ""
          }`;
      });
    }
    if (filterParam === undefined && filterForSearch?.length > 0) {
      filterForSearch.forEach((item: any) => {
        qp =
          qp +
          `${keyword || location ? "&" : ""}filter=${item}${
            filterForSearch.length > 1 ? "&" : ""
          }`;
      });
    }
    qp = qp + "&page=" + pageNo;
    return qp;
  };

  const handleSubmit = (event: any) => {
    dispatch(searchEventsCount(getSearchParam()));
    dispatch(searchEvent(getSearchParam())).then((res: any) => {
      if (!res.payload.length) {
        setEventData([]);
        setEventLoadingMessage("No matching event found");
      }
    });
  };

  const handleSelectChange = (event: any) => {
    event.stopPropagation();
    setFilterForSearch(event.target.value);
    setPageNo(1);
    // let filterParam = event.target.value[0];
    let otherParams = getSearchParam(event.target.value);
    // let queryString = `${otherParams}${otherParams?'&':''}filter=${filterParam}`
    if (event.target.value.length) {
      setIsLoading(true);
      dispatch(searchEventsCount(otherParams));
      dispatch(searchEvent(otherParams)).then((res) => {
        if (res.meta.requestStatus == "fulfilled") setIsLoading(false);
        if (!res.payload.length) {
          setEventData([]);
          setEventLoadingMessage("No matching event found");
          return;
        }
      });
    } else if (otherParams) {
      setIsLoading(true);
      dispatch(searchEventsCount(otherParams));
      dispatch(searchEvent(otherParams)).then((res) => {
        if (res.meta.requestStatus == "fulfilled") setIsLoading(false);
      });
    } else {
      setIsLoading(true);
      dispatch(totalEventCount());
      dispatch(listEvent(pageNo)).then((res) => {
        if (res.meta.requestStatus == "fulfilled") setIsLoading(false);
      });
    }

    const {
      target: { value },
    } = event;
    SetFilter(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleFormSubmission = (e: any, postBody: any, files: any ,idToDelete: any,
    timeSlots: any[]) => {
    e.preventDefault();
    let uploadFileResponse;
    setToastType("error");
    if (postBody.contact == "") {
      setToastMessage("All fields are mandatory!");
      setOpenToaster(true);
      return null;
    } else if (postBody.title == "") {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.dept == "" || postBody.dept == undefined) {
      setToastMessage("All fields are mandatory!");
      setOpenToaster(true);
      return null;
    } else if (
      postBody.location == "" ||
      postBody.location == "Select Location"
    ) {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.allGoals == null || postBody.allGoals.length === 0) {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    } else if (postBody.venue == "") {
      setToastMessage("All fields are mandatory!");
      setOpenToaster(true);
      return null;
    } else if (postBody.eventCategory?.id == "") {
      setToastMessage("All fields are Mandatory");
      setOpenToaster(true);
      return null;
    }
    //  else if (postBody.allslots == "" || postBody.allslots == null) {
    //   setToastMessage("All fields are mandatory!");
    //   setOpenToaster(true);
    //   return null;
    // }
     else if (!postBody.eventSlots || postBody.eventSlots.length === 0) {
      setToastMessage("All fields are mandatory!");
      setOpenToaster(true);
      return null;
    }
     else if (
      postBody.description.replace(/<(.|\n)*?>/g, "").trim().length === 0
    ) {
      setToastMessage("Event description is mandatory");
      setOpenToaster(true);
      return false;
    } else if (!files.length) {
      setToastMessage("Feature image is required!");
      setOpenToaster(true);
      return null;
    } else if (files.length > 5) {
      setToastMessage("More then 5 images are not allowed!");
      setOpenToaster(true);
      return null;
    } else if (!validateEventDates(postBody)) {
      return null;
    } else {
      var filter =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!filter.test(postBody.contact)) {
        setToastMessage("Please enter a valid email address");
        setOpenToaster(true);
        return false;
      } else {
        let emailDomain = postBody.contact.split("@");
        if (emailDomain[1] != "mercedes-benz.com") {
          setToastMessage("Only Mercedes Benz email is allowed!");
          setOpenToaster(true);
          return false;
        }
      }
    }

    let formData = new FormData();
    let images: any = [];
    for (let index = 0; index < files.length; index++) {
      images.push(files[index]["name"]);
      formData.append("images", files[index], files[index].name);
    }

    formData.append("event", JSON.stringify(postBody));

    dispatch(createEvent(formData)).then((res) => {
      if (res.meta.requestStatus == "fulfilled") {
        setDisablePublish(false);
        setToastType("success");
        setToastMessage("New event created successfully!");
        setOpenToaster(true);
        setIsLoading(true);
        dispatch(totalEventCount());
        dispatch(listEvent(pageNo)).then((res) => {
          if (res.meta.requestStatus == "fulfilled") setIsLoading(false);
        });
        handlePopupClose();
        setCreateEventBody({
          title: "",
          imagePath: "",
          imageName: "",
          description: "",
          location: "",
          venue: "",
          eventStartDate: dayjs(""),
          eventStartTime: dayjs(""),
          eventEndDate: dayjs(""),
          eventEndTime: dayjs(""),
          registrationStartDate: dayjs(""),
          registrationStartTime: dayjs(""),
          registrationEndDate: dayjs(""),
          registrationEndTime: dayjs(""),
          allslots: null,
          allGoals: [],
          totalSlots: null,
          contact: "",
          createdBy:
            user.userName == "" || user.userName == undefined
              ? "ADMIN_USER"
              : user.userName,
          eventCategory: {
            id: "",
          },
        });
        setLocation("");
      } else {
        setDisablePublish(false);
        setToastType("error");
        setToastMessage("Failed to create this event!");
        setOpenToaster(true);
        return null;
      }
    });

    setDisablePublish(true);
  };

  const validateEventDates = (data: any) => {
    let registrationStartDateTime = new Date(
      data.registrationStartDate + " " + data?.registrationStartTime
    );
    let registrationEndDateTime = new Date(
      data.registrationEndDate + " " + data?.registrationEndTime
    );
    let eventstartDateTime = new Date(
      data.eventStartDate + " " + data?.eventStartTime
    );
    let eventEndDateTime = new Date(
      data.eventEndDate + " " + data?.eventEndTime
    );

    if (
      dayjs(registrationStartDateTime).isAfter(
        dayjs(registrationEndDateTime)
      ) ||
      dayjs(registrationStartDateTime).isSame(dayjs(registrationEndDateTime))
    ) {
      setToastMessage(
        "Registration end date must be greater then registration start date."
      );
      setOpenToaster(true);
      return false;
    } else if (
      dayjs(registrationStartDateTime).isAfter(dayjs(eventstartDateTime)) ||
      dayjs(registrationStartDateTime).isSame(dayjs(eventstartDateTime))
    ) {
      setToastMessage(
        "Registration start date must be before event start date."
      );
      setOpenToaster(true);
      return false;
    } else if (
      dayjs(registrationEndDateTime).isAfter(dayjs(eventstartDateTime)) ||
      dayjs(registrationEndDateTime).isSame(dayjs(eventstartDateTime))
    ) {
      setToastMessage("Registration end date must be before event start date.");
      setOpenToaster(true);
      return false;
    } else if (
      dayjs(eventstartDateTime).isAfter(dayjs(eventEndDateTime)) ||
      dayjs(eventstartDateTime).isSame(dayjs(eventEndDateTime))
    ) {
      setToastMessage("Event start date must be before event end date.");
      setOpenToaster(true);
      return false;
    } else return true;
  };

  const [createEventBody, setCreateEventBody] = React.useState<any>({
    title: "",
    imagePath: "",
    imageName: "",
    description: "",
    location: "",
    venue: "",
    eventStartDate: dayjs(""),
    eventStartTime: dayjs(""),
    eventEndDate: dayjs(""),
    eventEndTime: dayjs(""),
    registrationStartDate: dayjs(""),
    registrationStartTime: dayjs(""),
    registrationEndDate: dayjs(""),
    registrationEndTime: dayjs(""),
    allslots: null,
    totalSlots: null,
    dept: "",
    allGoals: [],
    contact: "",
    createdBy:
      user.userName == "" || user.userName == undefined
        ? "ADMIN_USER"
        : user.userName,
    eventCategory: {
      id: "",
    },
  });

  React.useEffect(() => {
    dispatch(totalEventCount());
    dispatch(listEvent(pageNo)).then((res) => {
      if (res.meta.requestStatus == "fulfilled") setIsLoading(false);
    });
    dispatch(fetchEventCategories());
  }, []);

  React.useEffect(() => {
    if (keyword != "") handleSubmit(event);
    else if (location != "") handleSubmit(event);
    else if (filterForSearch.length > 0) handleSubmit(event);
    else dispatch(listEvent(pageNo));
  }, [pageNo]);

  React.useEffect(() => {
    if (eventCategories && eventCategories.length > 0) {
      let categories = eventCategories.map((ec: any) => {
        return ec.name;
      });
      setFilters(categories);
    }
  }, [eventCategories]);

  React.useEffect(() => {
    if (events && events.length > 0) {
      setEventData(events);
    }
  }, [events]);

  React.useEffect(() => {
    dispatch(totalEventCount());
    setTotal(Math.ceil(totelEveCount / 9));
  }, [eventData]);

  const handlePageChange = (pageNumber: any, value: any) => {
    setPageNo(value);
    scrollToTop();
    window.scrollTo(0, 0);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleClose = () => {
    setSelectOpen(false);
  };

  return (
    <React.Fragment>
      <Container maxWidth="lg">
        <Typography mt={4} variant="h3">
          Our Volunteering Events
        </Typography>
        <Box mb={3} sx={{ flexGrow: 1 }}>
          <Grid pt={4} container rowSpacing={1}>
            <Grid size={{ sm: 8 }}>
              <Paper
                className="search-form"
                component="form"
                sx={{ p: "2px 4px", display: "flex", alignItems: "center" }}
              >
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search with any keyword"
                  name="keyword"
                  onChange={handleInputChange}
                  inputProps={{
                    sx: {
                      "&::placeholder": {
                        color: "#505050",
                        opacity: 1, // otherwise firefox shows a lighter color
                        fontSize: "18px",
                      },
                    },
                    onKeyDown: (e) => {
                      if (e.key === "Enter") {
                        handleSubmit(e);
                      }
                    },
                  }}
                />

                <Divider
                  sx={{ height: 28, m: 0.5, backgroundColor: "#000" }}
                  orientation="vertical"
                />

                <FormControl variant="standard" className="location-search-box">
                  <Select
                    labelId="simple-select-label"
                    displayEmpty
                    renderValue={
                      location !== "" ? undefined : () => "Search by location"
                    }
                    id="simple-select"
                    value={location}
                    onChange={handleChange}
                    sx={{ width: "90%" }}
                    variant="standard"
                    disableUnderline
                  >
                    <MenuItem value={""}>Select Location</MenuItem>
                    <MenuItem value={"bengaluru"}>Bengaluru</MenuItem>
                    <MenuItem value={"pune"}>Pune</MenuItem>
                    <MenuItem value={"virtual"}>Virtual</MenuItem>
                  </Select>
                </FormControl>
                <IconButton
                  type="button"
                  onClick={handleSubmit}
                  sx={{
                    p: "10px",
                    backgroundColor: "#0078D6",
                    color: "#d6e9f8",
                    marginBottom: "10px",
                  }}
                  aria-label="search"
                >
                  <SearchIcon />
                </IconButton>
              </Paper>
            </Grid>
            <Grid
              size={{ sm: 4 }}
              sx={{ alignSelf: "center", textAlign: "end" }}
            >
              {/* {user && user.userType == "ADMIN" && (
                <Button
                  variant="contained"
                  sx={{
                    textTransform: "capitalize",
                    borderRadius: 0,
                    height: "50px",
                    fontWeight: "600",
                    fontSize: "18px",
                  }}
                  onClick={openCreateEventForm}
                >
                  + Create Event
                </Button>
              )} */}

              <FormControl className="filterButton">
                <Select
                  labelId="multiple-checkbox-label"
                  id="multiple-checkbox"
                  displayEmpty
                  multiple
                  onClick={() => setSelectOpen(!selectOpen)}
                  value={filter}
                  MenuProps={{ disableScrollLock: true }}
                  onChange={handleSelectChange}
                  input={<OutlinedInput placeholder="Filter" />}
                  className="filterSelect"
                  onClose={handleClose}
                  open={selectOpen}
                  renderValue={() => {
                    return (
                      <Typography
                        variant="body1"
                        component="span"
                        color="#fff"
                        sx={{ fontSize: "1.125rem", fontWeight: 600 }}
                      >
                        Filter
                        <FilterListIcon
                          sx={{ marginLeft: "8px", verticalAlign: "bottom" }}
                        />
                      </Typography>
                    );
                  }}
                >
                  {filters &&
                    filters.length > 0 &&
                    filters.map((name: any) => (
                      <MenuItem key={name} value={name}>
                        <Checkbox checked={filter.indexOf(name) > -1} />
                        <ListItemText primary={name} />
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        {isLoading ? (
          <Loader />
        ) : (
          <Box mt={4} mb={4} sx={{ flexGrow: 1 }}>
            <Grid container spacing={5}>
              {eventData &&
                eventData.length > 0 &&
                eventData?.map((event, index) => (
                  <Grid key={index} size={{ xs: 12, sm: 2, md: 4 }}>
                    <EventCard key={index} event={event} />
                  </Grid>
                ))}

              {eventData.length == 0 && (
                <>
                  <Grid size={{ xs: 2, sm: 4, md: 4 }}>
                    <Typography mt={10} mb={2} variant="h6">
                      {eventLoadingMessage}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
            <Stack alignItems={"center"} p={5} spacing={2}>
              {eventData && eventData.length > 0 && (
                <Pagination
                  count={total}
                  page={pageNo}
                  onChange={handlePageChange}
                  color="primary"
                />
              )}
            </Stack>
          </Box>
        )}

        <Toaster
          openToaster={openToaster}
          toastMessage={toastMessage}
          type={toastType}
          handleToasterClose={handleToasterClose}
        />
        {open && (
          <EventForm
            open={open}
            handleClose={handlePopupClose}
            title={createEventFormTitle}
            data={createEventBody}
            handleChange={setCreateEventBody}
            submitForm={handleFormSubmission}
            disablePublish={disablePublish}
            openToasterForm={openToaster}
          />
        )}
      </Container>
    </React.Fragment>
  );
}
